import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import postData from "../../../lib/Axios";
import { showError } from "../../../lib/GeneralFunction";
import { useRouter } from "next/router";
import Link from "next/link";
import { useState } from "react";
import axios from "axios";

const RegisterForm = ({ toast, state, setFieldValue, setErrors, setState }) => {
  const router = useRouter();
  const apiDirPath = "/api/daftar/register/";

  const [registerState, setRegisterState] = useState({
    load: false,
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Harus diisi"),
    password: Yup.string().min(8, "Pasword minimal 8 karakter").required("Harus diisi"),
    name: Yup.string().required("Harus diisi"),
    time_zone: Yup.string().required("Harus diisi"),
    no_hp: Yup.string()
      .max(15, "Maksimal nomor hp adalah 15 karakter")
      .min(11, "Minimil nomor hp adalah 11 karakter")
      .required("Harus diisi"),
  });

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    setRegisterState((p) => ({ ...p, load: true }));
    try {
      const data = {
        email: state?.values?.email,
        password: state?.values?.password,
        name: state?.values?.name,
        no_hp: state?.values?.no_hp,
        alamat: state?.values?.alamat,
        time_zone: state?.values?.time_zone,
      };

      let isError = false;
      await validationSchema.validate(data, { abortEarly: false }).catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });

        if (Object.keys(newErrors).length > 0) {
          isError = true;
        }
        setErrors(newErrors);
      });

      if (isError) {
        return;
      }

      const header = { "Content-Type": "application/json;charset=UTF-8" };

      const payload = {
        email: data.email,
        password: data.password,
        name: data.name,
        no_hp: data.no_hp,
        alamat: data.alamat,
        time_zone: data.time_zone,
      };

      const { data: oRes } = await axios.post("/api/daftar/register", payload, {
        headers: header,
      });

      router.push("/auth/login");
    } catch (error) {
      const e = error?.response?.data?.status || error;
      console.log("asdasd", e)
      showError(toast, e.message || "Internal server error");
    } finally {
      setRegisterState((p) => ({ ...p, load: false }));
    }
  };

  return (
    <>
      <form onSubmit={onHandleSubmit} className="p-fluid">
        <div className="flex gap-2 w-full">
          <div className="field mb-4 w-full">
            <label htmlFor="email" className="block text-900 font-medium mb-2">
              Email
            </label>
            <InputText
              readOnly
              id="email"
              type="text"
              value={state?.values?.email}
              onChange={(e) => setFieldValue("email", e.target.value)}
              className={classNames({ "p-invalid": state?.errors?.email })}
              placeholder="test@gmail.com"
              style={{ padding: "1rem" }}
            />

            {state?.errors?.email && <small className="p-error block">{state?.errors?.email}</small>}
          </div>
          {
            <div className="field mb-4 w-full">
              <label htmlFor="noWa" className="block text-900 font-medium mb-2">
                Contact WhatsApp
              </label>
              <InputText
                readOnly
                id="noWa"
                keyfilter={"int"}
                value={state?.values?.no_hp}
                onChange={(e) => setFieldValue("no_hp", e.target.value)}
                className={classNames({ "p-invalid": state?.errors?.no_hp })}
                placeholder="089111222333"
                style={{ padding: "1rem" }}
              />
              {state?.errors?.no_hp && <small className="p-error block">{state?.errors?.no_hp}</small>}
            </div>
          }
        </div>
        {
          <>
            <div className="field mb-4 w-full">
              <label htmlFor="name" className="block text-900 font-medium mb-2">
                Nama
              </label>
              <InputText
                id="name"
                type="text"
                value={state?.values?.name}
                onChange={(e) => setFieldValue("name", e.target.value)}
                className={classNames({ "p-invalid": state?.errors?.name })}
                placeholder="Nama Lengkap"
                style={{ padding: "1rem" }}
              />
              {state?.errors?.name && <small className="p-error block">{state?.errors?.name}</small>}
            </div>

            <div className="field mb-4 w-full">
              <label htmlFor="alamat" className="block text-900 font-medium mb-2">
                Alamat
              </label>
              <InputTextarea
                id="alamat"
                type="text"
                value={state?.values?.alamat}
                onChange={(e) => setFieldValue("alamat", e.target.value)}
                className={classNames({ "p-invalid": state?.errors?.alamat })}
                style={{ padding: "1rem" }}
              />
              {state?.errors?.alamat && <small className="p-error block">{state?.errors?.alamat}</small>}
            </div>

            <div className="field mb-4">
              <label htmlFor="password" className="block text-900 font-medium mb-2">
                Password
              </label>
              <Password
                id="password"
                value={state?.values?.password}
                onChange={(e) => setFieldValue("password", e.target.value)}
                toggleMask
                feedback={false}
                className={classNames({ "p-invalid": state?.errors?.password })}
                inputClassName="w-full"
                placeholder="password"
              />
              {state?.errors?.password && <small className="p-error block">{state?.errors?.password}</small>}
            </div>

            <div className="field mb-4">
              <label htmlFor="time_zone" className="block text-900 font-medium mb-2">
                Zona waktu
              </label>
              <Dropdown
                id="time_zone"
                value={state?.values?.time_zone}
                onChange={(e) => setFieldValue("time_zone", e.value)}
                options={[
                  { label: "WIB", value: "wib" },
                  { label: "WITA", value: "wita" },
                  { label: "WIT", value: "wit" },
                ]}
                optionLabel="label"
                optionValue="value"
                className={classNames({ "p-invalid": state?.errors?.time_zone })}
                inputClassName="w-full"
                placeholder="Zona waktu"
              />
              {state?.errors?.time_zone && <small className="p-error block">{state?.errors?.time_zone}</small>}
            </div>
          </>
        }

        <div className="flex gap-2 mt-4">
          <button
            style={{
              borderRadius: "2px",
              padding: "0.75rem",
              border: "none",
            }}
            className={`flex align-items-center justify-content-between gap-2 rounded bg-green-500 text-white font-medium hover:bg-green-600 disabled:bg-gray-400 transition w-full`}
            disabled={registerState?.load}
            type="submit">
            <>
              <i className={`${registerState?.load ? "pi pi-spin pi-spinner" : "pi pi-user"}`}></i>
              <span className="w-full">{state?.isVerified ? "Sign Up" : "Kirim Otp"}</span>
            </>
          </button>

          <Link
            href={"/auth/login"}
            style={{
              borderRadius: "2px",
              padding: "0.75rem",
            }}
            className={`flex align-items-center text-center justify-content-between gap-2 rounded bg-yellow-500 text-white font-medium hover:bg-yellow-600 disabled:bg-gray-400 transition w-full`}>
            <>
              <i className={`${registerState.load ? "pi pi-spin pi-spinner" : "pi pi-user"}`}></i>
              <span className="w-full">Sign In</span>
            </>
          </Link>
        </div>
      </form>
    </>
  );
};

export default RegisterForm;
